import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/Previlage/Fetcher'
import ActionDelete from '../../store/action/Previlage/Delete'
import CustomGridSearch from '../../infra/components/grid/custom-grid-with-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Privilege",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-12',id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-5", field: "privilege-name", caption: "Privilege", allowSearch: true },
                { className : "col-sm-2", field: "status", caption: "Status", allowSearch: true },
                { className : "col-sm-2", cfield: "action", caption: "Actions", allowView: false }    
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

    componentDidMount(){
        const { formSearch } = this.state;
        this.props.actionGet(1, formSearch);
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.props.actionGet();
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.props.actionGet(page, search);
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "privilege-id":value.get('privilege-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('privilege-name') +' Success!', toast.POSITION.BOTTOM_RIGHT);
            this.props.actionGet();
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('privilege-name') +' Failed!', toast.POSITION.BOTTOM_RIGHT);
        }
    }

    showContent(){
        var form = this.state.form;
        
        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.previlages ? fromJS(this.props.previlages) : fromJS({});

            return (
                <CustomGridSearch 
                    title="Privilege"
                    columns={ this.state.columns  } 
                    items={ items }  
                    search={ this.state.search }
                    handleNew={ this.handleNew }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGridSearch>
            )
        }
    }

    render(){
        const { form } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Privilege"  : "Edit Privilege"  ) : "Previlege";
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
        previlages: state.user.previlages,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionDelete: ActionDelete,
  }, dispatch),
)(Page);